import { TasksGroup } from "@common-models/task-group";
import { Stack } from "@mui/system";
import { getCurrentBoard, doesGroupBelongToAudienceBoard } from "@common-reducers/BoardsSelectors";
import { taskgroupsSelectors } from "@common-reducers/DBServiceThunks";
import { useAppDispatch } from "@common-reducers/hooks/store.hook";
import { ReactElement, memo, useCallback, useState } from 'react';
import { DragDropContext, DraggableProvided, DropResult, Droppable } from "react-beautiful-dnd";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import GroupColumnItem from "./group-column-item";
import classes from "./group_header.module.scss";
import { columnListForDisplaySelector } from "@common-reducers/TaskSelectors";
import { updateColumnOrderAfterTaskDragEnd } from "@common-reducers/TaskThunks";
interface Props {
  groupId: string;
  provided: DraggableProvided;
}

function GroupHeader({ groupId, provided: parentProvided }: Props): ReactElement {
  const dispatch = useAppDispatch()
  const isAudienceBoard = useAppSelector((state) => doesGroupBelongToAudienceBoard(state, groupId));
  const isDisplayChat = !isAudienceBoard;

  const isGroupDragging = useAppSelector(state => state.TasksReducer.isGroupDragging)
  const [draggingOver, setDraggingOver] = useState<string | null>(null);

  const board = useAppSelector(getCurrentBoard)

  const tasksGroup: TasksGroup = useAppSelector((state) => {
    return taskgroupsSelectors.selectById(state, groupId)
  });


  // const collapsed = tasksGroup?.isCollapsed || isGroupDragging;
  //const activeColumn = useAppSelector((state) => state.TasksReducer.activeColumn)
  //const isSortPendingSave = useAppSelector((state) => state.TasksReducer.isSortPendingSave)

  let columnList = useAppSelector(state => columnListForDisplaySelector(state, tasksGroup?.boardId, groupId))
    .filter(col => (col.type === 'chat' && isDisplayChat) || (col.type !== 'chat'));

  const onDragEnd = useCallback(
    (result: DropResult) => {
      if (result.destination?.index === undefined) {
        return;
      }


      if (result.source.index === result.destination.index) {
        return;
      }


      const sourceEl = columnList[result.source?.index];
      const destinationEl = columnList[result.destination.index];

      if ((destinationEl.order ?? 0) >= 1000) {
        return;
      }
      dispatch(updateColumnOrderAfterTaskDragEnd({
        sourceColumnId: sourceEl._id ?? null,
        destinationBoardId: destinationEl.boardId ?? null,
        destinationOrder: destinationEl.order ?? 0,
        dragDirection: result.destination.index - result.source?.index
      }))
    }, [columnList, dispatch]);


  return (
    <DragDropContext
      onDragStart={() => {
      }}
      onDragUpdate={(update) => {
        setDraggingOver(update.destination?.droppableId || null);
      }}
      onDragEnd={onDragEnd}>
      <Droppable direction="horizontal" droppableId={`column_droppable_${tasksGroup?._id}`}  >
        {
          (droppableProvided, droppableSnapshot) => {
            return <Stack
              data-testid='column-header-row'
              direction="row"
              ref={droppableProvided.innerRef}
              className={classes.todoRow}
              {...droppableProvided.droppableProps}
            >

              {columnList.map((column, index) => {
                const isDraggingOver = draggingOver === `column_${tasksGroup?._id}_${column?._id}`;
                const columnKey = `column_${tasksGroup?._id}_${column._id}_${isDraggingOver}`
                return <GroupColumnItem
                  key={columnKey}
                  column={column}
                  index={index}
                  tasksGroup={tasksGroup}
                  board={board}
                  isGroupDragging={isGroupDragging}
                  columnListLength={columnList.length}
                  isDraggingOver={isDraggingOver}
                  parentProvided={parentProvided} />

              })}
              {droppableProvided.placeholder}
            </Stack>
          }
        }
      </Droppable>
    </DragDropContext>
  );
}

export default memo(GroupHeader);